<button pButton class="p-button-raised p-button-text cbms-row-button" (click)="toggleSelectRow()"
        [pTooltip]="templateId? 'Select template':'Unselect template'" showDelay="1000" hideDelay="500">
    <mat-icon svgIcon="select_hand"></mat-icon>
</button>